<template>
    <b-modal modal-class="modal fade align-content-center" id="modal-archive-contact" hide-footer hide-header>
        <div class="modal-dialog modal-lg">
            <div class="modal-content px-5 py-3">
                <div class="modal-header justify-content-center border-0">
                    <h3 class="modal-title font-nunito text-danger modal-title-archive">{{ $t('archive-contact') }}</h3>
                </div>
                <div class="modal-body">
                    <p class="fs-13 text-black font-nunito" v-html="$t('archive-contact-details')"></p>
                </div>
                <div class="modal-footer border-0">
                    <button type="button" class="btn text-btn style-btn font-nunito mr-4" ref="closeBtn" @click="cancelArchive()"
                        data-dismiss="modal" id="close">
                        {{ $t('cancel') }}
                    </button>
                    <button type="button" class="btn bg-danger rounded-pill text-white font-nunito fs-14" @click="archiveContact()">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" :disabled="disabled" v-if="loading"></span>
                        {{ $t('archive-contact') }}
                    </button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>

// Internal services js
import Alert                 from '../../../helpers/Alert.js';

// Import external libraries
import { mapState, mapActions } from 'vuex';
import moment                   from 'moment';

export default {
    props: ['contactId'],

    data () {
        return {
            loading:        false,
            profilePicture: '',
            disabled:       true
        };
    },

    computed: {
        ...mapState('core/auth', [
            'user'
        ])
    },

    mounted () {
        this.loadProfilePicture();
    },

    methods: {
        ...mapActions('core/contacts', [
            'patch'
        ]),

        /**
         * Get and show the user profile picture
         */
        loadProfilePicture () {
            // If user have a profile picture
            if (this.user.attributes['profile-picture']) {
                // Use timestamp (Date.now()) show the new image.
                this.profilePicture = `${this.user.attributes['profile-picture']}?${Date.now()}`;
                return;
            }

            this.profilePicture = null;
        },

        /**
         * Archive Contact
         */
        archiveContact () {
            this.loading = true;

            this.patch({
                id:         this.contactId,
                attributes: { 'deleted-at': moment().format() }
            })
                .then(() => {
                    Alert.success(this.$i18n.t('contact-is-archived'));
                    this.$bvModal.hide('modal-archive-contact');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        /**
         * Cancel the update and show the original contact information.
         */
        cancelArchive () {
            this.disabled = true;
            this.loading   = false;
            this.$refs.closeBtn.click();
            this.$bvModal.hide('modal-archive-contact');
        }

    }
};
</script>
